import { useFormContext } from 'react-hook-form';
import ClassificationDeclarations from '@/components/ui/ClassificationDeclarations/ClassificationDeclarations';
import type { SupportedFormData } from './schemas/supportedFormSchema';

const DeclarationsSection = () => {
  const { setValue } = useFormContext<SupportedFormData>();

  return (
    <div className="flex flex-col gap-6 w-[763px] max-md:w-full">
      <ClassificationDeclarations
        onRequiredFilled={(allFilled) => setValue('declarationsComplete', allFilled)}
      />
    </div>
  );
};

export default DeclarationsSection;

